import { Filters } from './useDailyClearingsScreen';
import { useEffect } from 'react';
import { useShallowEqualSelector } from '../../utils/reduxUtils';
import { useDispatch } from 'react-redux';
import { Loadable, ClearingSummaryTable, Currency } from '@card/types';
import { ClearingsActions } from './actions';
import { startOfMonth, endOfMonth, subMonths } from 'date-fns';
import { useEventTracker } from '@increasecard/increase-core';

export interface UseDailyDataOptions {
  filters: Filters;
  dateRange: Date[];
  currency: Currency | undefined;
}

export function useDailyData({ filters, dateRange, currency }: UseDailyDataOptions) {
  const dispatch = useDispatch();
  const tracker = useEventTracker();
  const dailySummary: Loadable<ClearingSummaryTable[]> = useShallowEqualSelector(
    (s) => s.clearings.daily
  );

  const createReport = ({ filters, dateRange, currency }: UseDailyDataOptions) => {
    // eslint-disable-next-line @typescript-eslint/camelcase
    tracker.track('Generate report', { report_type: 'daily_payments' });
    dispatch(
      ClearingsActions.createReportStarted({
        filters,
        dateRange,
        currency
      })
    );
  };

  const handleCreateReport = () => {
    createReport({ filters, dateRange, currency });
  };

  const handleCreateReportLastMonth = () => {
    const lastMonth = subMonths(new Date(), 1);
    createReport({
      filters,
      dateRange: [startOfMonth(lastMonth), endOfMonth(lastMonth)],
      currency
    });
  };

  useEffect(() => {
    dispatch(
      ClearingsActions.fetchDailyStarted({
        filters,
        dateRange,
        currency
      })
    );
  }, [dispatch, filters, dateRange, currency]);

  return { dailySummary, handleCreateReport, handleCreateReportLastMonth };
}
